import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["funnelData"]

  switchTab(event) {
    event.preventDefault()

    const clickedButton = event.currentTarget
    const sourceType = clickedButton.dataset.source

    // Update active tab button
    this.updateActiveTab(clickedButton)

    // Show corresponding funnel data
    this.showFunnelData(sourceType)
  }

  updateActiveTab(activeButton) {
    // Remove active class from all tab buttons
    const allTabs = this.element.querySelectorAll('.nav-link')
    allTabs.forEach(tab => tab.classList.remove('active'))

    // Add active class to clicked button
    activeButton.classList.add('active')
  }

  showFunnelData(sourceType) {
    // Hide all funnel data containers
    this.funnelDataTargets.forEach(container => {
      container.classList.add('d-none')
    })

    // Show the selected funnel data container
    const targetContainer = this.funnelDataTargets.find(
      container => container.dataset.source === sourceType
    )

    if (targetContainer) {
      targetContainer.classList.remove('d-none')
    }
  }
}